import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-[130px] l:mt-[155px]" }

import Index from '@/components/About/Index.vue';
import Index2 from '@/components/About/Index2.vue';
import { useWindowSize } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'About',
  setup(__props) {

const { width } = useWindowSize();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(width) < 768)
      ? (_openBlock(), _createBlock(Index2, { key: 0 }))
      : (_openBlock(), _createBlock(Index, { key: 1 }))
  ]))
}
}

})